module.exports = __webpack_public_path__ + "img/1.c74558cd.png";